import {
  Button,
  Col,
  Divider,
  notification,
  Popconfirm,
  Row,
  Space,
  Switch,
  Table,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "../../../../../../utils/tms-with-router/tms-with-router";
import tmsRouteMap from "../../../../../../constants/tms-route.map";
import moment from "moment";
import {
  LeaseInvoice,
  LicenseInstitutionSelect,
  LicenseLeaseSelect,
  SortTypeAndBy,
} from "../../../../../../components/tms-customs/rents-and-leases/index";
import BillAdjustment from "../../../../../../components/tms-customs/rents-and-leases/bill-adjustment";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import { useReactToPrint } from "react-to-print";
import { DeleteOutlined } from "@ant-design/icons";
import {
  additionalLicenseArrearStates,
  arrearLicenseStates,
} from "../../../../../../constants/states-data.data";
import useLicensesStore from "../../../../../../zustand/licenses.store";
import TmsExcelButton from "../../../../../../components/tms-customs/tms-excel-button";

const TmsSmLicenseArrearList = ({ router }) => {
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(10);
  const [sortType, setSortType] = useState("ASC");
  const [sortBy, setSortBy] = useState("createdAt");
  const [update, setUpdate] = useState("");
  const [editFlag, setEditFlag] = useState(false);
  const [editData, setEditData] = useState(false);
  const [view, setView] = useState(false);
  const [adjustedAmount, setAdjustedAmount] = useState("");
  const [adjustedAmountRemarks, setAdjustedAmountRemarks] = useState("");
  const refContainer = useRef(null);

  const {
    selectedInstitution,
    loading,
    clearStates,
    fetchInstitutionList,
    fetchArrearsByLease,
    createdArrearsData,
    handleArrearUpdate,
    handleArrearBillUpdate,
    deleteCreatedArrear,
    deleteLoading,
    fetchLeaseInvoices,
    fetchLicenseLeases,
    selectedLicenseLease,
    excelLoading,
    handleExcelExport,
  } = useLicensesStore();

  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
    if (sorter.field === "createdAt") {
      if (sorter.order === "ascend") {
        setSortType("ASC");
      } else if (sorter.order === "descend") {
        setSortType("DESC");
      }
    }
  };
  useEffect(() => {
    return () => {
      clearStates(arrearLicenseStates, additionalLicenseArrearStates);
    };
  }, []);

  useEffect(() => {
    router.location.pathname === tmsRouteMap.sm_ral_license_arears_creation &&
      fetchInstitutionList(1, 200, "ASC", "createdAt", router);
  }, [router.location.pathname]);
  useEffect(() => {
    if (selectedInstitution && selectedInstitution !== "")
      fetchLicenseLeases(1, 200, "ASC", "createdAt", router);
  }, [selectedInstitution]);

  useEffect(() => {
    if (
      selectedInstitution &&
      selectedInstitution !== "" &&
      selectedLicenseLease &&
      selectedLicenseLease !== ""
    )
      fetchArrearsByLease(
        tableCurrentPage,
        tablePageSize,
        sortType,
        sortBy,
        router
      );
  }, [
    sortBy,
    tableCurrentPage,
    tablePageSize,
    sortType,
    selectedInstitution,
    selectedLicenseLease,
    update,
  ]);
  const handlePrint = useReactToPrint({
    content: () => refContainer.current,
    copyStyles: true,
    bodyClass: "tms-lease-container",
    onAfterPrint: () => {
      setView(false);
    },
  });

  const handleUpdate = async (record, status) => {
    const records = { ...record, status: status };
    await handleArrearUpdate(records, router);
    setUpdate(Math.random() * 100000 + 21);
  };
  return (
    <>
      <Row justify="flex-start" gutter={[20, 20]}>
        <LicenseInstitutionSelect span={5} />
        <LicenseLeaseSelect span={5} />
        <SortTypeAndBy
          span={5}
          sortBy={sortBy}
          sortType={sortType}
          setSortBy={setSortBy}
          setSortType={setSortType}
        />{" "}
        {selectedInstitution !== "" && selectedInstitution && (
          <Col style={{ padding: "0" }}>
            <p style={{ visibility: "hidden", paddingBottom: "4px" }}>.</p>
            <TmsExcelButton
              loading={excelLoading}
              handleExcelExport={() => handleExcelExport("arrear", router)}
              top={false}
            />
          </Col>
        )}
      </Row>
      <br />
      <Table
        className={" accomadation_table captalise-center mt-10 "}
        tableLayout="fixed"
        scroll={{ x: "max-content" }}
        loading={loading}
        columns={[
          {
            title: "S.no",
            key: "sno",
            width: 70,
            render: (text, object, index) => index + 1,
          },
          {
            title: "Lesse Name",
            dataIndex: "licenseLease",
            render: (record) => record.licenseFee,
          },

          {
            title: "License Name",
            dataIndex: "licenseLease",
            render: (record) => record?.license?.licenseName,
          },

          {
            title: "Lease Period From & To",
            dataIndex: "licenseLease",
            render: (record) =>
              `${moment(record?.licensePeriodStartDate).format(
                "DD-MM-YYYY"
              )} to ${moment(record?.licensePeriodEndDate).format(
                "DD-MM-YYYY"
              )}`,
          },

          {
            title: "License Fee",
            dataIndex: "licenseLease",
            render: (record) => record.licenseFee,
          },
          {
            title: "Arrear Amount",
            dataIndex: "arrearAmount",
          },
          {
            title: "Arrear Period",
            dataIndex: "arrearPeriodInMonths",
          },
          {
            title: "Arrear Period",
            dataIndex: "arrearPeriodInMonths",
          },
          {
            title: "Mobile",
            dataIndex: "licenseLease",
            render: (record) => record.mobileNumber,
          },

          {
            title: "Status",
            key: "status",
            render: (record) => {
              return (
                <Switch
                  size={"small"}
                  checked={record.status}
                  onClick={() => {
                    handleUpdate(record, !record.status);
                  }}
                />
              );
            },
          },
          {
            title: "Actions",
            key: "status",
            render: (record) => {
              return (
                <Space>
                  <a
                    onClick={async () => {
                      try {
                        let records = await fetchLeaseInvoices(
                          record.id,
                          true,
                          1,
                          200,
                          "ASC",
                          "createdAt",
                          router
                        );
                        if (!records?.id) {
                          notification.error({
                            message: "No latest invoices are generated",
                          });
                          return;
                        } else {
                          setView(true);
                          setEditData(records);
                        }
                      } catch (e) {
                        console.log(e);
                        setView(false);
                        notification.error({
                          message: "No latest invoices",
                        });
                        setEditData({});
                      }
                    }}
                  >
                    View
                  </a>
                  <Divider type="vertical" />
                  <a
                    style={{ whiteSpace: "pre" }}
                    onClick={() => {
                      setEditData(record);
                      setEditFlag(true);
                    }}
                  >
                    Bill Adjustment
                  </a>{" "}
                  <Divider type="vertical" />
                  <Space size="middle">
                    <Popconfirm
                      title="Are you sure delete this arrear?"
                      onConfirm={async () => {
                        await deleteCreatedArrear(record.id, router);
                        setUpdate(Math.random() * 100000 + 21);
                      }}
                      okText="Yes"
                      cancelText="No"
                      loading={deleteLoading}
                    >
                      <DeleteOutlined />
                    </Popconfirm>
                  </Space>{" "}
                </Space>
              );
            },
          },
        ].map((item) => {
          return { ...item, align: "center" };
        })}
        dataSource={createdArrearsData?.items ?? []}
        onChange={handleTableChange}
        pagination={{
          total: createdArrearsData?.meta?.totalItems ?? 0,
          current: tableCurrentPage,
          pageSize: tablePageSize,
        }}
      ></Table>
      <TmsModal
        visible={view}
        width={"50%"}
        onOk={() => {
          setView(false);
          setEditData({});
        }}
        closable={true}
        centered
        onCancel={() => {
          setView(false);
          setEditData({});
        }}
      >
        <Row justify={"center"}>
          <Button onClick={handlePrint} type="primary">
            Print
          </Button>
        </Row>
        <br />
        <LeaseInvoice
          data={editData}
          type="land-lease"
          refContainer={refContainer}
          scantype={"payment"}
        />
      </TmsModal>
      <BillAdjustment
        type="license-lease"
        editFlag={editFlag}
        setEditFlag={setEditFlag}
        loading={loading}
        editData={{
          licenseName: editData?.licenseLease?.license?.licenseName,
          natureOfBusiness: "-",
          lesseName: editData?.licenseLease?.licenseeName ?? "-",
          lesseType: editData?.licenseLease?.licenseeType,
          leaseAmount: Number(editData?.licenseLease?.licenseFee),
          arrearAmount: editData?.arrearAmount ?? 0,
          arrearId: editData?.id,
          licenseLeaseId: editData?.licenseLeaseId,
        }}
        setEditData={setEditData}
        adjustedAmount={adjustedAmount}
        setAdjustedAmount={setAdjustedAmount}
        adjustedAmountRemarks={adjustedAmountRemarks}
        setAdjustedAmountRemarks={setAdjustedAmountRemarks}
        handleArrearBillUpdate={handleArrearBillUpdate}
        setUpdate={setUpdate}
        router={router}
      />
    </>
  );
};

export default withRouter(TmsSmLicenseArrearList);
